// src/components/FormWizard.js
import React, { useState } from 'react';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Step1 from './Step1';
import FinalStep from './FinalStep';
import Confirmation from './Confirmation';
import ProgressTracker from './ProgressTracker';
import TermsOfService from '../pages/TermsOfService';

const FormWizard = () => {
  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const updateFormData = (stepData) => {
    setFormData(prevData => ({ ...prevData, ...stepData }));
  };

  const nextStep = () => {
    if (currentStep === 1) {
      setCurrentStep(2);
      navigate('/final-step');
    } else {
      navigate('/confirmation');
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(1);
      navigate('/step1');
    }
  };

  const renderStep = (Step) => {
    return (
      <Step
        formData={formData}
        updateFormData={updateFormData}
        nextStep={nextStep}
        prevStep={prevStep}
      />
    );
  };

  const isFullScreenRoute = location.pathname === '/terms-of-service';

  if (isFullScreenRoute) {
    return (
      <Routes>
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    );
  }

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
      <div className="w-full lg:w-1/4 bg-blue-600 text-white p-4 lg:p-8 flex flex-col">
        <div className="mb-6 lg:mb-12">
          <img src='/logo.png' alt="Logo" className="h-[50px] mb-6 bg-white px-4 py-2 rounded-xl" />
          <h2 className="text-lg font-semibold">Onboarding Form</h2>
        </div>
        <ProgressTracker currentStep={currentStep} />
        <div className="mt-auto pt-8 text-xs lg:text-sm text-blue-200">
          All rights reserved @InCall IQ
        </div>
      </div>
      <div className="w-full lg:w-3/4 p-4 lg:p-8 overflow-auto flex flex-col">
        <div className="max-w-3xl mx-auto w-full">
          <Routes>
            <Route path="/step1" element={renderStep(Step1)} />
            <Route path="/final-step" element={renderStep(FinalStep)} />
            <Route path="/confirmation" element={<Confirmation formData={formData} />} />
            <Route
              path="/"
              element={
                <Step1
                  formData={formData}
                  updateFormData={updateFormData}
                  nextStep={nextStep}
                  prevStep={prevStep}                    
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default FormWizard;
